import HistoryView from './HistoryView';

export default HistoryView;



// WEBPACK FOOTER //
// ./src/views/payoutsAndTaxes/history/index.js